<template>
  <div :class="['l-login', { 'l-login-phone': !isPC, 'l-login-width-full': isWidthFull }]">
    <div class="l-login-wrapper">
      <img src="./images/l-login-logo.png" alt="" class="l-img-logo" />
      <transition-group name="login">
        <div class="l-login-inner" v-if="isShowLogin && !isShowForget" :key="1">
          <div class="l-tab-box">
            <div class="l-tab" :class="{ active: showPhone }" @click="showPhone = true">
              短信登录
            </div>
            <div class="l-tab" :class="{ active: !showPhone }" @click="showPhone = false">
              密码登录
            </div>
          </div>
          <div class="l-login-main">
            <!-- 账号登录 -->
            <div class="l-login-box l-login-account" v-if="!showPhone">
              <div class="l-input-box">
                <img src="./images/l-login-account.png" alt="" class="l-img-icon" />
                <input type="text" placeholder="请输入账号" autocomplete="new-password" v-model.trim="form.phone"
                  class="l-input" maxlength="11" />
              </div>
              <div class="l-input-box">
                <img src="./images/l-login-password.png" alt="" class="l-img-icon" />
                <input :type="passType" autocomplete="new-password" placeholder="请输入密码" v-model.trim="form.password"
                  class="l-input" />
                <img src="./images/l-login-show.png" alt="" class="l-img-see" v-if="!isSee" @click="onChangeType" />
                <img src="./images/l-login-hide.png" alt="" class="l-img-see" v-else @click="onChangeType" />
              </div>

              <div class="l-password-container">
                <!-- 记住密码 -->
                <div class="l-password-wrapper">
                  <input type="checkbox" id="l-password" :checked="isRemember" @change="onHandleChange" />
                  <label for="l-password" class="l-label">
                    <div class="l-icon"></div>
                    <div class="l-text">记住密码</div>
                  </label>
                </div>
                <!-- 忘记密码 -->
                <span class="l-forget-wrapper" @click="isShowForget = true">忘记密码？</span>
              </div>
            </div>
            <!-- 短信登录 -->
            <div class="l-login-box l-login-phone" v-else>
              <div class="l-input-box">
                <img src="./images/l-login-phone.png" alt="" class="l-img-icon" />
                <input type="text" placeholder="请输入手机号" autocomplete="new-password" v-model.trim="form.phone"
                  class="l-input" maxlength="11" />
              </div>
              <div class="l-input-box">
                <img src="./images/l-login-captcha.png" alt="" class="l-img-icon" />
                <input type="text" placeholder="请输入图形验证码" autocomplete="new-password" v-model.trim="form.captchaKey"
                  class="l-input" maxlength="5" ref="captchakey" v-on:input="onChangeLength(1)" />
                <img :src="imgUrl" alt="" @click="onGetCaptchaKey" class="l-img-captcha" />
              </div>
              <div class="l-input-box">
                <img src="./images/l-login-code.png" alt="" class="l-img-icon" />
                <input type="text" placeholder="请输入验证码" autocomplete="new-password" v-model.trim="form.verifyCode"
                  class="l-input" maxlength="5" ref="verifycode" v-on:input="onChangeLength(2)" />
                <button type="button" class="l-btn-code">
                  <span @click="onGetSMS()" v-if="!isShowCaptchaButton" class="l-code-text">获取验证码</span>
                  <span v-else class="l-code-time">{{ captchaCount }}s</span>
                </button>
              </div>
            </div>
            <button class="l-btn-login" @click="onLogin">立即登录</button>
          </div>
        </div>
        <ForgetPassword :key="2" :phone="form.phone" @submit="onSubmit" @cancel="onCancel" v-if="isShowForget" />
      </transition-group>
    </div>
    <LFooter />
  </div>
</template>

<script>
import LFooter from '../layout/footer'
import ForgetPassword from './components/forget-password'
import UsercenterModel from '@/models/usercenter'
import version from "@/utils/version"

const usercenterModel = new UsercenterModel()

export default {
  components: { LFooter, ForgetPassword },
  data() {
    return {
      captchaCount: 60, // 倒计时
      isShowCaptchaButton: false, // 获取验证码按钮
      isShowLogin: false, // 展示页面
      isShowForget: false, // 忘记密码
      showPhone: true, // 短信登录
      isSee: false, // 是否可见
      isRemember: true, // 默认记住密码
      isPC: version.isPC(), // 是否是PC
      isWidthFull: true, // 背景图宽度100%
      passType: 'password', // input类型
      imgSrc: "/api/usercenter/common/captcha?captchaKey=", // 图形验证码接口
      imgUrl: "", // 图形验证码
      LOCAL_KEY: 'LOGIN_INFO', // 缓存登录信息
      form: {
        phone: '',
        password: '',
        captchaKey: '',
        verifyCode: '',
        source: 3, // 请求来源  1:安卓 2:ios 3:pc 4:wap
        type: 1 // 登录类型: 1:手机号密码 2:手机号图形验证码短信验证码
      }
    }
  },
  mounted() {
    let timer = setTimeout(() => {
      this.isShowLogin = true
      clearTimeout(timer)
    }, 300)
    let _this = this
    window.onresize = () => {
      _this._pageResize()
    }
    _this._pageResize()
  },
  created() {
    this.onGetCaptchaKey()
    // 记住密码功能
    if (localStorage.getItem(this.LOCAL_KEY)) {
      const params = JSON.parse(localStorage.getItem(this.LOCAL_KEY))
      this.form.phone = params.phone
      this.form.password = params.password
    }
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    onGetCaptchaKey() {
      const timestamp = Math.round(new Date().getTime() / 1000)
      this.imgUrl = this.imgSrc + timestamp
    },
    onLogin() {
      let newForm = { ...this.form }
      let submitForm
      if (!this.showPhone) { // 账号登录
        newForm.type = 1
        delete newForm.captchaKey
        delete newForm.verifyCode
        submitForm = newForm
        if (submitForm.phone == '' || submitForm.password == '') {
          this.$lPrompt({
            message: '请您输入正确的账号和密码',
            successTxt: '确定',
            successFn: function () { },
          })
          return
        }
      } else { // 短信登录
        newForm.type = 2
        delete newForm.captchaKey
        delete newForm.password
        submitForm = newForm
        if (submitForm.phone == '' || submitForm.captchaKey == '' || submitForm.verifyCode == '') {
          this.$lPrompt({
            message: '请您输入正确的手机号、图形验证码和验证码',
            successTxt: '确定',
            successFn: function () { },
          })
          return
        }
      }
      usercenterModel.login(submitForm)
        .then((res) => {
          if (res.data) {
            if (this.isRemember && !this.showPhone) { // 密码登录而且记住密码
              const params = {
                phone: this.form.phone,
                password: this.form.password
              }
              localStorage.setItem(this.LOCAL_KEY, JSON.stringify(params))
            } else if (!this.isRemember && !this.showPhone) { // 密码登录而且不记住密码
              localStorage.removeItem(this.LOCAL_KEY)
            }

            /**
             * 登录成功(跨域登录逻辑)
             * - 缓存用户信息(上一步已经完成)
             * - 如没有redirect_uri 默认跳转到同环境的学习
             */
            let nowUser = localStorage.getItem('USER') ? JSON.parse(localStorage.getItem('USER')) : ''
            localStorage.setItem('USER', JSON.stringify(res.data))
            usercenterModel.getTokenCode({
              token: res.data.token
            }).then(ress => {
              console.log('获取登录code:' + ress.data)
              let defaultUrl = `https://${(process.env.VUE_APP_ENV === 'prod' ? 'bhbl' : process.env.VUE_APP_ENV + '-bhbl')}.dayuan1997.com?code=${ress.data}`
              let current = new URL(window.location.href)

              let redirect_uri = current.search.split('redirect_uri=')[1]
              if (redirect_uri && redirect_uri !== "undefined") {
                let realUrl = new URL(decodeURIComponent(redirect_uri))
                console.log('realUrl', realUrl)
                if (nowUser && nowUser.userId != res.data.userId) { // 两次登录用户不一致
                  window.location.href = realUrl.origin + '?code=' + ress.data
                } else if (current.host === realUrl.host) {
                  window.location.href = defaultUrl
                } else {
                  realUrl.searchParams.delete('code')
                  realUrl.searchParams.set('code', ress.data)
                  window.location.href = realUrl.href
                }
              } else {
                window.location.href = defaultUrl
              }
            })
          }
        })
        .catch((error) => {
          if (error.status === usercenterModel.HTTPSTATUS.VERIFY_STATUS_EXPIRED) {
            this.$lPrompt({
              message: '请您输入正确的验证码',
              successTxt: '确定'
            })
          } else if (error.status === usercenterModel.HTTPSTATUS.PASSWORD_ERROR) {
            this.$lPrompt({
              message: '对不起，您的用户名或密码错误！',
              successTxt: '确定'
            })
          } else {
            this.$lPrompt({
              message: error.msg,
              successTxt: '确定'
            })
          }
        })
    },
    // 获取验证码
    onGetSMS() {
      if (this.form.phone == '' || this.form.captchaKey == '') {
        this.$lPrompt({
          message: '请您输入正确的手机号、图形验证码',
          successTxt: '确定',
          successFn: function () { },
        })
        return
      }
      const codeForm = {
        phone: this.form.phone,
        captcha: this.form.captchaKey
      }
      usercenterModel.getVerifyCode(codeForm).then(() => {
        this.isShowCaptchaButton = true
        this._countdown()
      }).catch((error) => {
        this.$lPrompt({
          message: error.msg,
          successTxt: '确定'
        })
      })
    },
    // 60s倒计时
    _countdown() {
      this.countdownTimer = setInterval(() => {
        this.captchaCount--
        if (this.captchaCount === 0) {
          clearInterval(this.countdownTimer)
          this.isShowCaptchaButton = false
          this.captchaCount = 60
        }
      }, 1000)
    },
    // input类型
    onChangeType() {
      if (this.isSee) {
        this.isSee = false
        this.passType = 'password'
      } else {
        this.isSee = true
        this.passType = 'text'
      }
    },
    // 切换选中
    onHandleChange() {
      this.isRemember = !this.isRemember
    },
    // 监听输入
    onChangeLength(type) {
      // 1图形验证码  2短信验证码
      if (type == 1) {
        if (this.form.captchaKey.length >= 5) {
          this.$refs.verifycode.focus()
        }
      } else {
        if (this.form.verifyCode.length >= 5) {
          this.$refs.verifycode.blur()
        }
      }
    },
    // 屏幕拖动
    _pageResize() {
      const windowWidth = document.documentElement.clientWidth  // 屏幕宽度
      const windowHeight = document.documentElement.clientHeight  // 屏幕高度
      const imgProportion = 1920 / 1080  // 背景图宽高比
      this.isWidthFull = windowWidth / windowHeight >= imgProportion
      console.log('this.isWidthFull', this.isWidthFull)
    },
    // 修改密码 - 确定
    onSubmit(val) {
      this.isShowForget = false
      this.form.phone = val
    },
    // 修改密码 - 取消
    onCancel() {
      this.isShowForget = false
    },
  }
}
</script>

<style lang="stylus" scoped>
@import './login.styl'
</style>

